import type { ReactNode } from 'react';

type BareLayoutProps = {
  children?: ReactNode;
};

// Renders children only, with no navbar/footer chrome. Used for auth-style
// pages (e.g. Admin/Login) that need a blank canvas.
export const BareLayout = ({ children }: BareLayoutProps) => {
  return <div className="bg-background min-h-screen">{children}</div>;
};
